import { usePostListEntryClickHandler } from "../../Presentation/Pages/GroupDetailsPage/Hooks/usePostDetailsNavigator";
import { PostDetailsPageActions } from "../../Presentation/Components/Modals/PostDetailsModal/PostDetailsModal";

export function usePostDetailsNavigationActions() {
    const redirectToPostHandler = usePostListEntryClickHandler();
    function navigateToPostWithAction(
        postId: string | number,
        desiredAction?: PostDetailsPageActions,
        commentId?: string | number,
    ) {
        redirectToPostHandler(
            postId.toString(),
            desiredAction
                ? {
                      desiredAction: desiredAction,
                      commentId: commentId?.toString(),
                  }
                : undefined,
        );
    }

    return { navigateToPostWithAction };
}
